export default __webpack_public_path__ + "static/media/action-play_white.c5ab57c4.svg";